import { Injectable } from "@angular/core";

import { Field } from "@shared/field.model";
import { TextboxField } from "@shared/field-textbox";
import { DatePickerField } from "@shared/field-datepicker";
import { TimePickerField } from "@shared/field-timepicker";
import { CheckboxField } from "@shared/field-checkbox";
import { Validators } from "@angular/forms";
import { TextareaField } from "@app/shared/field-textarea";
@Injectable({
  providedIn: "root",
})
export class F2FEmailFieldService {
  constructor() {}

  getFields(portalMode = "") {
    let fields: Field<any>[] = [
      new TextboxField({
        key: "name",
        id: "refer-name",
        label: "Nombre",
        value: "",
        required: true,
        validations: [Validators.required],
        errorMessages: [
          {
            rule: "required",
            message: "Ingresa tu nombre",
          },
        ],
        order: 1,
      }),

      new TextboxField({
        key: "email",
        id: "refer-email",
        label: "Correo",
        value: "",
        required: true,
        validations: [Validators.required, Validators.email],
        errorMessages: [
          {
            rule: "required",
            message: "Ingresa tu correo",
          },
          {
            rule: "email",
            message: "Ingresa correo con formato correcto",
          },
        ],
        order: 2,
      }),

      new TextboxField({
        key: "phoneNumber",
        id: "refer-phoneNumber",
        label: "Número celular",
        value: "",
        required: true,
        config: {
          maxLength: 13,
        },
        validations: [Validators.required, Validators.pattern("^[0-9]+$")],
        errorMessages: [
          {
            rule: "required",
            message: "Ingresa número de celular",
          },
          {
            rule: "pattern",
            message: "Ingresa solo numeros",
          },
        ],
        order: 3,
      }),
    ];

    if (portalMode === "F2F") {
      fields = [
        //...fields,
        new TextareaField({
          key: "textMessage",
          id: "refer-textMessage",
          label: "Mensaje a tu referido",
          classes: "w-100",
          value: `Hola @@client_name

Soy @@seller_name, tu oficial de Banco Guayaquil, te escribo porque quiero agradecer tu visita a nuestra agencia y me gustaría aprovechar para compartir contigo los principales beneficios de uno de los productos que nuestro aliado estratégico Chubb Seguros ha diseñado para nuestros clientes.

¡Siempre queremos lo mejor para ti!.`,
          required: true,
          validations: [Validators.required],
          errorMessages: [
            {
              rule: "required",
              message: "Ingresa mensaje",
            },
          ],
          order: 4,
        }),
      ];
    }

    return fields.sort((a, b) => a.order - b.order);
  }
}
